import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import classes from "./LLMIndicator.module.css";
import { OVERVIEW_LLM_LABELS } from "../../../utils/constant";

const LLMIndicator = ({ llm }) => {
  const llmName =OVERVIEW_LLM_LABELS[llm] || "";

  return (
    <div className={classes.container}>
      <InfoOutlinedIcon className="icon" />
      <span className={classes.truncate}>Generated by {llmName}</span>
    </div>
  );
};

export default LLMIndicator;
